// managed
// Generate Input Template Request interface for use across the project
export interface GenerateInputTemplateRequest {
  id?: string;
  user_id?: string;
  product?: string;
  experimental_conditions?: Record<string, any>;
  time_points?: Record<string, number[]>;
  analysis_types?: string[];
  desired_output_summary?: string;
  desired_outputs?: string[];
}

export function createEmptyGenerateInputTemplateRequest(): GenerateInputTemplateRequest {
  return {
    id: undefined,
    user_id: undefined,
    product: undefined,
    experimental_conditions: {},
    time_points: {},
    analysis_types: [],
    desired_output_summary: undefined,
    desired_outputs: [],
  };
}

// Helper function to validate GenerateInputTemplateRequest object
export function isGenerateInputTemplateRequest(obj: any): obj is GenerateInputTemplateRequest {
  return obj && typeof obj === 'object';
}

// Helper function to clone GenerateInputTemplateRequest object
export function cloneGenerateInputTemplateRequest(item: GenerateInputTemplateRequest): GenerateInputTemplateRequest {
  return {
    ...item,
  };
}

// JSON Schema for Fastify route validation and OpenAPI documentation
export const GenerateInputTemplateRequestSchema = {
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "example": "123e4567-e89b-12d3-a456-426614174000"
    },
    "user_id": {
      "type": "string",
      "example": "greg.perry@metalytics.com"
    },
    "product": {
      "type": "string",
      "example": "MFALite"
    },
    "experimental_conditions": {
      "description": "Experimental conditions with metadata",
      "example": {
        "Condition_1": {
          "genetic_parent": "Clone A",
          "product_type": "IgG1",
          "media_type": "Media_X"
        }
      }
    },
    "time_points": {
      "description": "Process time points in days per condition",
      "example": {
        "ConditionA": [
          0,
          3,
          5,
          7,
          10,
          14
        ]
      }
    },
    "analysis_types": {
      "type": "array",
      "items": {
        "type": "string"
      },
      "example": [
        "metabolites",
        "amino_acids",
        "dipeptides",
        "perfusion",
        "biomass",
        "igg",
        "process"
      ]
    },
    "desired_output_summary": {
      "type": "string",
      "example": "Generate a summary of the expected outputs and analyses included in the template."
    },
    "desired_outputs": {
      "type": "array",
      "items": {
        "type": "string"
      },
      "example": [
        "metabolite concentrations",
        "amino acid profiles",
        "IgG titers",
        "process parameters"
      ]
    }
  }
}
